import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/api/profile.service';
import { EmailType } from 'src/app/models/email-type';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-emails-unsubscribe',
    templateUrl: './emails-unsubscribe.component.html',
    styleUrls: ['./emails-unsubscribe.component.scss'],
    standalone: false
})
export class EmailsUnsubscribeComponent implements OnInit {

  loading = true;
  success = false;
  error: string = null;

  userId: string;
  token: string;
  type: string;

  constructor(private profileService: ProfileService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.type = this.route.snapshot.queryParamMap.get('type');

    this.profileService.unsubscribeFromEmails(this.userId, this.token, this.type).subscribe(response => {
      this.loading = false;
      this.success = true;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

}
